var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 151.9 50",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M65 26.3c0 7.2-5.6 12.5-12.5 12.5S40 33.5 40 26.3s5.6-12.5 12.5-12.5S65 19.1 65 26.3zm-5.5 0c0-4.5-3.3-7.6-7-7.6-3.8 0-7 3.1-7 7.6s3.3 7.6 7 7.6c3.8 0 7-3.1 7-7.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    d: "M92 26.3c0 7.2-5.6 12.5-12.5 12.5S67 33.5 67 26.3s5.6-12.5 12.5-12.5S92 19.1 92 26.3zm-5.4 0c0-4.5-3.3-7.6-7-7.6s-7 3.1-7 7.6 3.3 7.6 7 7.6 7-3.1 7-7.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M118 14.6V37c0 9.2-5.4 13-11.9 13-6.1 0-9.7-4.1-11.1-7.4l4.8-2c.9 2 2.9 4.4 6.3 4.4 4.1 0 6.7-2.5 6.7-7.3V36h-.2c-1.2 1.5-3.6 2.8-6.6 2.8-6.2 0-12-5.4-12-12.4 0-7.1 5.7-12.5 12-12.5 3 0 5.3 1.3 6.6 2.8h.2v-2l5.2-.1zm-4.9 11.8c0-4.4-2.9-7.6-6.7-7.6-3.8 0-7 3.2-7 7.6 0 4.4 3.2 7.5 7 7.5s6.7-3.2 6.7-7.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M126.5 1.4V38h-5.4V1.4h5.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "m147.4 30.4 4.3 2.8c-1.4 2-4.7 5.5-10.4 5.5-7.1 0-12.4-5.5-12.4-12.5 0-7.4 5.3-12.5 11.8-12.5 6.5 0 9.7 5.2 10.7 7.9l.6 1.4-16.7 6.9c1.3 2.5 3.3 3.8 6.1 3.8 2.6.2 4.6-1.2 6-3.3zm-13.1-4.5 11.2-4.6c-.6-1.6-2.5-2.6-4.6-2.6-2.9-.1-6.8 2.4-6.6 7.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M19.7 23.1v-5.3h17.9c.2.9.3 2 .3 3.2 0 4-1.1 8.9-4.6 12.4-3.4 3.5-7.8 5.4-13.5 5.4C9 38.8 0 30.1 0 19.4S9 0 19.7 0C25.6 0 29.8 2.3 33 5.3L29.3 9c-2.3-2-5.4-3.7-9.6-3.7-7.8 0-13.9 6.3-13.9 14.1s6.1 14.1 13.9 14.1c5.1 0 7.9-2 9.8-3.9C31 28.1 32 26 32.4 23l-12.7.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.6d57124e056b3519f7534f7e7682c8b4.svg";
export { ForwardRef as ReactComponent };